import React, { useState, useEffect } from 'react'
import { validateInputs, getRequestData } from '../Utitlity'
import './filters.css'
import classes from './Filter.module.css'
import UpgradeModal from '../../UpgradeModal/UpgradeModal'
import {Activity, currentRequestTimeStamp, isMobile} from '../../../Constants'
import MultiSelectWithCheckbox from '../../Shared/MultiSelectCheckbox/MultiSelectCheckbox'

const Filters = ({
    // skipactive = 0,
    setskipactive,
    // selectedFilters = [],
    setSelectedFilters,
    getTransportersList,
    availableFilters = [],
    // selectedfield=[],
    setSelectedfield = [],
    selectedfieldfetched = [],
    origin = {},
    destination = {},
    field,
    inputDestination = '',
    inputOrigin = '',
    transitTime = '',
    preferredTruck = '',
    // userType = 'basic',
    isFilterAllowed = 'yes'}) => {

        // const [currentSelected, setCurrentSelected] = useState(selectedFilters)
        // const [currentAvailableFilters, setcurrentAvailableFilters] = useState(availableFilters)
        const [truck_type, setTruck_type] = useState([])
        // const [transport_type, setTransport_type] = useState([])
        const [industryType, setIndustryType] = useState([])
        const [selectedtruck, setSelectedtruck] = useState([])
        // const [show, setShow] = useState([])
        // const [selectedtransport, setSelectedtransport] = useState([])
        const [selectedIndustry, setSelectedIndustry] = useState([])
        // const [zones, setZones] = useState([])
        // const [selectedZones, setSelectedZones] = useState([])
        // const [show, setShow] = useState(false)

        // const FiltersTabs = [...new Set(availableFilters.map(item => item.filter))]
        useEffect(() => {

            var available_truck = []
            // var available_transport = []
            // var available_industry = []
            setSelectedtruck([])
            setTruck_type([])
            setIndustryType([])
            // setSelectedtransport([])
            setSelectedIndustry([])
            var sel = []
            if(availableFilters && availableFilters.length>0){
                var c = 0;
                availableFilters.map((newfilter)=>{
                    if(newfilter.filter === 'truck_type'){
                        available_truck.push(newfilter)
                        if(newfilter.isChecked === true){
                            c= c+1;
                            if(!(sel.includes(newfilter))) {
                                sel.push(newfilter)
                            }
                        }
                    }
                })
                setSelectedtruck(sel)
                setTruck_type(available_truck)
            }
            var industrylist = []
            if(field){

                if(field.industry_list && field.industry_list.length >0){
                    field.industry_list.map(val=>{
                        industrylist.push({label:val, value:val, field:'industry'})
                    })
                    setIndustryType(industrylist)
                }
            }
        }, [availableFilters, field])
        
        useEffect(() => {
            setSelectedIndustry([])
            if(selectedfieldfetched && selectedfieldfetched.length > 0){
                var indlist = []
                selectedfieldfetched[0].value.map(val=>{
                    if(val !== 'ALL'){
                        indlist.push({label:val, value:val, field:'industry'})
                    }
                })
                setSelectedIndustry(indlist)
            }
        }, [selectedfieldfetched])

        const updateFilters = (e, filteritem) => {
            const newValues = filteritem === 'trucktype' ? [...e] : [...selectedtruck, ...e];
            const fieldList = filteritem === 'industry' ? [...e] : [];
          
            if (filteritem === 'trucktype') {
              setSelectedIndustry([]);
            }
          
            setSelectedFilters(newValues);
            setSelectedfield(fieldList);
          
            if (validateInputs(origin, inputOrigin, destination, inputDestination)) {
              setskipactive(1);
              const requestData = getRequestData(
                origin,
                inputOrigin,
                destination,
                inputDestination,
                newValues,
                fieldList,
                0,
                transitTime,
                preferredTruck
              );
              Activity([
                {
                  screen: "DiscoverNow",
                  module: "Filter",
                  user_activity: { request_data: requestData },
                  timestamp: currentRequestTimeStamp(),
                },
              ]);
              getTransportersList(requestData);
            }
        };
          
        const newtruckselected = (e) => {
            const selected = Array.isArray(e) ? e : [];
            updateFilters(selected, 'trucktype');
            setSelectedtruck(selected);
        };
        
        const newindustryselected = (e) => {
        const selected = Array.isArray(e) ? e : [];
        updateFilters(selected, 'industry');
        setSelectedIndustry(selected);
        };

    return !isMobile()?
        <>{
            isFilterAllowed  === 'yes'? <div className="row" style={{marginLeft:'1%',width:'100%', marginBottom:'2%'}}>
            <div className="col-md-4">
                <div style={{width:'100%',  color:'black', fontSize:'15px'}}>
                    Truck Type
                </div>
                <MultiSelectWithCheckbox
                    options = {truck_type}
                    isMulti = {true}
                    onChange = {e=>newtruckselected(e)}
                    value = {selectedtruck}
                />
            </div>
            <div className="col-md-4" >
                <span style={{width:'100%',  color:'black', fontSize:'15px'}}>Industry Type</span>
                <MultiSelectWithCheckbox
                    options = {industryType}
                    onChange = {e=>newindustryselected(e)}
                    value = {selectedIndustry}
                />
            </div>
        </div>
        :
        <div className="row" style={{ width: '100%'}}>
            <div style={{ display: 'inline-flex', width: '100%', justifyContent: 'center'}}>
                <center style={{ marginTop: '5px'}}><span style={{ fontSize: '14px'}}>Want to view transporters by Truck Types and industry? Upgrade to Enterprise Plans</span></center>
                <UpgradeModal 
                    buttonClass={`btn btn-sm btn-success ${classes['filterss']}`} 
                    buttonLabel={<><span style={{ fontSize: '14px', marginLeft: '1%' }}>Premium Plans</span></>}
                    style={{width:'fit-content', marginLeft: '1%'}}
                    activityName="Upgrade Popup"
                    screenName="DiscoverNow"
                    moduleName="Filters"
                    feature="Filters"
                />
            </div>
        </div>
        }
        </>:<> {isFilterAllowed  === 'yes'?
        <div style={{width:'100%'}}>                
                <div style={{ fontSize:'15px'}}>
                    Truck Type
                </div>
                <MultiSelectWithCheckbox
                    options = {truck_type}
                    onChange = {e=>newtruckselected(e)}
                    value = {selectedtruck}
                />
                <div style={{marginTop:'1%'}}>
                <span style={{ fontSize:'15px'}}>Industry Type</span>
                <MultiSelectWithCheckbox
                    options = {industryType}
                    onChange = {e=>newindustryselected(e)}
                    value = {selectedIndustry}
                />
            </div>
        </div>:
        <div style={{justifyContent:'center', textAlign:'center', paddingBottom:'1%'}}>
        <div>
            <span>Want to filter by your industry, select Premium Plans Now</span>
        </div>
        <div style={{marginTop:'5%'}}>
            <UpgradeModal 
                buttonClass="btn btn-sm btn-success" 
                buttonLabel={<><span style={{ fontSize: '14px' }}>Premium Plans</span></>}
                style={{width:'fit-content'}}
                activityName="Upgrade Popup"
                screenName="DiscoverNow"
                moduleName="Filters"
                feature="Filters"
            />
        </div>
    </div>}
    </>
}

export default Filters
